import { MixpanelTracker } from '@stilingue/st-analytics';

let mixPanelIntance;

export function insertMixpanelPlugin({
  universeId,
  accountId,
  userId,
  userEmail,
  userName,
  admin,
  avatarUrl,
  createdAt,
  emailConfirmed,
  initialPasswordChanged,
  intercomHash,
  paymentKind,
  readOnly,
  role,
  roleId,
  userGroup,
}) {
  mixPanelIntance = new MixpanelTracker({
    user: {
      id: userId,
      email: userEmail,
    },
    universe: {
      id: universeId,
    },
    account: {
      id: accountId,
    },
    peopleData: {
      admin,
      avatarUrl,
      createdAt,
      emailConfirmed,
      initialPasswordChanged,
      intercomHash,
      paymentKind,
      readOnly,
      role,
      roleId,
      user_group: userGroup,
      $name: userName,
      $email: userEmail,
    },
    config: {
      token: process.env.VUE_APP_MIXPANEL_API_KEY,
      name: process.env.NODE_ENV,
    },
  });
}

export function trackEvent(eventName, properties) {
  mixPanelIntance.track(eventName, properties);
}

export function getMixpanelInstance() {
  return mixPanelIntance.mixpanelInstace();
}
